import { render, staticRenderFns } from "./CreatePackage.vue?vue&type=template&id=8cf85a9a&scoped=true"
import script from "./CreatePackage.vue?vue&type=script&lang=js"
export * from "./CreatePackage.vue?vue&type=script&lang=js"
import style0 from "./CreatePackage.vue?vue&type=style&index=0&id=8cf85a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf85a9a",
  null
  
)

export default component.exports